import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eos-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
